export default __webpack_public_path__ + "static/media/cert-fsi-HKIRC.215ecdf8.jpg";